import { render, staticRenderFns } from "./RouteDetailsEta.vue?vue&type=template&id=2c872439&scoped=true"
import script from "./RouteDetailsEta.vue?vue&type=script&lang=ts"
export * from "./RouteDetailsEta.vue?vue&type=script&lang=ts"
import style0 from "./RouteDetailsEta.vue?vue&type=style&index=0&id=2c872439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c872439",
  null
  
)

export default component.exports